import { StyledContainer } from "./styles";
import { ContainerProps } from "../types";

const Container = ({
  border,
  children,
  padding,
  narrow,
  className,
}: ContainerProps) => (
  <StyledContainer
    $border={border}
    $padding={padding}
    $narrow={narrow}
    className={className}
  >
    {children}
  </StyledContainer>
);

export default Container;
